import config from '../config/config'

export function getVideoUrl (
  moduleName: string | null,
  modulePart: number | null = null,
  isEad: boolean = false,
  captionsLang: string = 'en'
): [videoUrl: string, captionsUrl: string] {
  if (moduleName === null) {
    return ['', '']
  }

  const courseFilesUrl = config.loadEnvironmentVariables().courseFilesUrl
  const baseVideosUrl = `${courseFilesUrl}video`
  const baseCaptionsUrl = `${courseFilesUrl}captions`

  const moduleNameLower = moduleName.toLowerCase()
  const suffixEad = isEad ? '_ead' : ''
  const suffixPart = modulePart !== null ? `_${modulePart.toString()}` : ''
  const extCaptionsLang = captionsLang.length > 0 ? `.${captionsLang.toLowerCase()}` : ''

  const videoUrl = `${baseVideosUrl}/${moduleNameLower}${suffixPart}${suffixEad}.mp4`
  const captionsUrl = `${baseCaptionsUrl}/${moduleNameLower}${suffixPart}${suffixEad}${extCaptionsLang}.vtt`

  return [videoUrl, captionsUrl]
}
